import { selectedCalendarsStore } from '../store/store';
import { ObservableMap } from 'mobx';
import { dedupeObservableMapValues } from 'owa-selected-calendars-utils';

export function getSelectedCalendars(): ObservableMap<string, string[]> {
    return dedupeObservableMapValues(selectedCalendarsStore().selectedCalendars);
}
